import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[maxDecimalPlacesValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MaxDecimalPlacesValidatorDirective, multi: true }],
    standalone: true,
})
export class MaxDecimalPlacesValidatorDirective implements Validator {
	@Input() maxDecimalPlacesValidator: number;

	validate(control: AbstractControl): ValidationErrors {
		if (control.value && +parseFloat(control.value).toFixed(this.maxDecimalPlacesValidator) !== +control.value) {
			return { maxDecimalPlaces: true };
		}

		return null;
	}
}
